"use client";
import { MenuIcon } from "@/icons";
import CustomICon from "./CustomIcon";
import { useAppDispatch } from "@/redux-store";
import { commonActions } from "@/redux-store/common.slice";

const HeaderToggleMenu = () => {
  const dispatch = useAppDispatch();

  const handleClickToggleMenu = () => {
    dispatch(commonActions.handleToggleMenu());
  };
  return (
    <CustomICon onClick={handleClickToggleMenu}>
      <MenuIcon />
    </CustomICon>
  );
};

export default HeaderToggleMenu;
